/**
 * AssistantPanel — Strategic Right Panel
 * Rule: RightPanelTip = strategic tip ("dlaczego" + "co teraz zrobić")
 * Separate from GhostBubbleTip (operational micro-action)
 */
import { Check, Lightbulb } from 'lucide-react';

export default function AssistantPanel({ title, step, totalSteps, whatNow, whyImportant, checklist }) {
  return (
    <div className="bg-white rounded-2xl overflow-hidden shadow-[0_2px_10px_rgba(0,0,0,0.04)] border border-zinc-200" data-testid="assistant-panel">
      {/* Header */}
      <div className="px-5 py-3.5 bg-gradient-to-r from-[#F47A3B] to-[#E06A2B]">
        <div className="flex items-center justify-between">
          <span className="text-white/80 text-[12px] font-medium">{title || 'Podpowiedzi'}</span>
          {step && totalSteps && (
            <span className="px-2.5 py-0.5 bg-white/20 backdrop-blur-sm rounded-full text-white text-[11px] font-bold">
              Krok {step} z {totalSteps}
            </span>
          )}
        </div>
      </div>

      <div className="p-5 space-y-5">
        {/* DLACZEGO TO WAŻNE — strategic insight */}
        {whyImportant && (
          <div>
            <div className="flex items-center gap-2 mb-2">
              <Lightbulb className="w-3.5 h-3.5 text-zinc-400" />
              <span className="text-[10px] font-bold text-zinc-400 uppercase tracking-wider">Dlaczego to ważne</span>
            </div>
            <p className="text-[13px] text-zinc-500 leading-relaxed">{whyImportant}</p>
          </div>
        )}

        {/* CO TERAZ? — next strategic step */}
        {whatNow && (
          <div>
            <div className="flex items-center gap-2 mb-2">
              <div className="w-2 h-2 bg-[#F47A3B] rounded-full animate-pulse" />
              <span className="text-[10px] font-bold text-[#F47A3B] uppercase tracking-wider">Co teraz</span>
            </div>
            <div className="rounded-xl p-4 bg-[#F47A3B]/5 border border-[#F47A3B]/10">
              <p className="text-[13px] font-medium text-zinc-900 leading-relaxed">{whatNow}</p>
            </div>
          </div>
        )}

        {/* POSTĘP */}
        {checklist && checklist.length > 0 && (
          <div>
            <h3 className="text-[10px] font-bold text-zinc-400 uppercase tracking-wider mb-3">Postęp</h3>
            <div className="space-y-1.5">
              {checklist.map((item, i) => {
                const status = item.done ? 'done' : item.active ? 'active' : 'pending';
                return (
                  <div key={i} className="flex items-center gap-2.5">
                    <div className={`w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 ${
                      status === 'done' ? 'bg-emerald-500'
                      : status === 'active' ? 'bg-[#F47A3B] ring-[3px] ring-[#F47A3B]/20'
                      : 'bg-zinc-200'
                    }`}>
                      {status === 'done' && <Check className="w-3 h-3 text-white" />}
                    </div>
                    <span className={`text-[12px] ${
                      status === 'done' ? 'text-zinc-400 line-through'
                      : status === 'active' ? 'text-[#F47A3B] font-semibold'
                      : 'text-zinc-300'
                    }`}>{item.label}</span>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
